<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/subadmin-mgt">Program Management </a>
            </li>
            <li class="breadcrumb-item">Edit</li>
        </ol>
        <div class="order-view mt30 mrgn-0-auto">
            <div class="main-block-innner">
                <div class="input-style">

                    <!-- **********************Subadmin profile image ****************  -->
                    <form [formGroup]="programForm">


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Program Type:</h6>
                            </label>
                            <div class="col-md-7">
                                <select name="" formControlName="programType"
                                    (change)="programTypeChange($event.target.value)" class="custom-select form-control"
                                    id="">
                                    <option value="">Select Program Type</option>
                                    @for (item of programTypeList; track item; let i = $index) {
                                    <option value="{{item?.programType}}">
                                        {{item?.programType}}</option>
                                    }
                                </select>
                                @if(programForm.get('programType')?.hasError('required') &&
                                programForm.get('programType')?.dirty){
                                <span>
                                    <small class="text-danger">*Program Type is required.</small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Title :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" placeholder="Title" formControlName="title"
                                    maxlength="256" (keypress)="inputkeyPress($event)" minlength="2">
                                @if(programForm.get('title')?.hasError('required') && programForm.get('title')?.dirty){
                                <span>
                                    <small class="text-danger">*Title is required.</small>
                                </span>
                                }
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Amount :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" [readonly]="IsFree" class="form-control" formControlName="amount"
                                    placeholder="Amount" (keypress)="service.inputKeyPress($event)" maxlength="50">
                                @if(programForm.get('amount')?.hasError('required') &&
                                programForm.get('amount')?.dirty){
                                <span>
                                    <small class="text-danger">*Amount is required.</small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Therapist Session :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" formControlName="therapistSession" class="form-control" value="24"
                                    placeholder="Therapist Session" (keypress)="service.inputKeyPress($event)"
                                    maxlength="50">

                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Medical Session :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" formControlName="MedicalSession" value="12"
                                    placeholder="Medical Session" (keypress)="service.inputKeyPress($event)"
                                    maxlength="50">

                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Case Manager Session:</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" formControlName="CaseManager" value="6"
                                    placeholder="Case Manager Session" (keypress)="service.inputKeyPress($event)"
                                    maxlength="50">

                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6>Is insurance package?</h6>
                            </label>
                            <div class="col-md-7">
                                <label class="md-check">
                                    <input type="radio" value="Yes" name="isInsurancePackage"
                                        formControlName="isInsurancePackage">
                                    Yes
                                </label>
                                &nbsp;
                                &nbsp;
                                <label class="md-check">
                                    <input type="radio" value="No" name="isInsurancePackage"
                                        formControlName="isInsurancePackage">
                                    No
                                </label>
                            </div>
                        </div>

                        <div class="form-group row align-items-center">
                            <label class="col-md-5">
                                <h6> Description: </h6>
                            </label>
                        </div>
                        <ckeditor rows="5" ngSkipHydration formControlName="description" maxlength="1000"
                            [editorUrl]="'//://cdn.ckeditor.com'">
                        </ckeditor>
                        @if(programForm.get('description')?.hasError('maxlength') &&
                        programForm.get('description')?.dirty){
                        <span>
                            <small class="text-danger">*Description must be less than 1000 character.</small>
                        </span>
                        }
                        @if(programForm.get('description')?.hasError('required') &&
                        programForm.get('description')?.dirty){
                        <span>
                            <small class="text-danger">*Description is required.</small>
                        </span>
                        }
                    </form>
                    <div class="text-center mt-3">
                        <button class="btn btn-theme" [disabled]="programForm.invalid"
                            (click)="editProgram()">Save</button>
                        <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                            routerLink="/program-mgt">Cancel</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</main>